import { SearchInput } from "PFApp/components/search_input";
import { Tabs } from "PFComponents/tabs";
import { Tab } from "PFComponents/tabs/tabs.types";
import { RecentSearchesPageKey } from "PFTypes/recent_searches";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { ImportModalPageType } from "../../constants/import_modal_page";
import { useImportModalContext } from "../../contexts/import_modal_context";
import css from "./import_modal_header.module.scss";

export type ImportModalHeaderProps = {
  importsCounter?: number;
  pageKey?: RecentSearchesPageKey;
};

export const ImportModalHeader = ({ importsCounter, pageKey }: ImportModalHeaderProps) => {
  const { t } = useTranslation();
  const { currentPage, setCurrentPage, search, setSearch } = useImportModalContext();

  const tabs: Tab<ImportModalPageType>[] = useMemo(
    () => [
      {
        id: ImportModalPageType.Upload,
        title: t("importFiles.newImport")
      },
      {
        id: ImportModalPageType.ImportHistory,
        count: importsCounter,
        title: t("importFiles.importHistory")
      }
    ],
    [importsCounter, t]
  );

  const selectedPage = useMemo(
    () =>
      ({
        [ImportModalPageType.Upload]: ImportModalPageType.Upload,
        [ImportModalPageType.ImportHistory]: ImportModalPageType.ImportHistory,
        [ImportModalPageType.ImportDataTable]: ImportModalPageType.ImportHistory
      })[currentPage],
    [currentPage]
  );

  return (
    <header className={css.header}>
      <Tabs<ImportModalPageType> tabs={tabs} activeTab={selectedPage} onChange={setCurrentPage} />
      {currentPage === ImportModalPageType.ImportHistory && pageKey && (
        <SearchInput pageKey={pageKey} onTermChange={setSearch} term={search || ""} />
      )}
    </header>
  );
};
